
import { Link } from 'react-router-dom';

interface LogoProps {
  className?: string;
}

export function Logo({ className }: LogoProps) {
  return (
    <Link to="/admin/dashboard" className="no-underline">
      <div className={`flex items-center gap-2 ${className}`}>
        <div className="w-8 h-8 bg-gradient-to-br from-green-600 to-green-800 rounded-lg flex items-center justify-center">
          <span className="text-white font-bold text-lg">T</span>
        </div>
        <span className="font-bold text-gray-800 dark:text-white">Thalvora Exports</span>
      </div>
    </Link>
  );
}